// Layout.js
import Button from 'components/Button';
import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { logout } from 'slice/userSlice';
import { useDispatch, useSelector } from 'react-redux';
import { IoPersonCircleSharp } from "react-icons/io5";
import { FaSlidersH, FaUsers } from "react-icons/fa";
import { MdDashboard } from "react-icons/md";
import { RiMedicineBottleLine } from "react-icons/ri";
import { IoReceiptOutline } from "react-icons/io5";
import { BsQrCode } from "react-icons/bs";
import { useNavigate } from 'react-router-dom';
import logo from '../asserts/img/logo.png';
import { toast } from 'react-toastify'
import { io } from "socket.io-client";
import { useLocation } from 'react-router-dom';

const socket = io(process.env.REACT_APP_BACKEND)
// const currentUrl = window.location.pathname;
// const lastSegment = currentUrl.substring(currentUrl.lastIndexOf('/') + 1);

const Layout = ({ children }) => {
    const [toggled, setToggle] = useState(true);
    const [openMenu, setOpenMenu] = useState(null);
    const dispatch = useDispatch();
    const nevigate = useNavigate();

    const { pathname } = useLocation();
    const lastSegment = pathname.split('/').pop();

    const protectedTabs = {
        dashboard: process.env.REACT_APP_DASHBOARD_PASSWORD,
        category: process.env.REACT_APP_DASHBOARD_PASSWORD,
        qrcode: process.env.REACT_APP_DASHBOARD_PASSWORD,
        banner: process.env.REACT_APP_DASHBOARD_PASSWORD,
        products: process.env.REACT_APP_DASHBOARD_PASSWORD,
        service: process.env.REACT_APP_DASHBOARD_PASSWORD,
        adminUser: process.env.REACT_APP_DASHBOARD_PASSWORD,
    };

    const closeMenu = () => {
        setOpenMenu(null);
    };



    const user = useSelector((state) => state.user);
    const [passwordInput, setPasswordInput] = useState("");
    const [passwordModalOpen, setPasswordModalOpen] = useState(false);
    const [currentProtectedTab, setCurrentProtectedTab] = useState(null);
    const [unlockedTabs, setUnlockedTabs] = useState({});



    const [notifications, setNotifications] = useState([]);
    // const [newBid, setNewBid] = useState([]);

    const audioRef = useRef(null);

    const handleTabClick = (tabName) => {
        setOpenMenu(null);
        if (protectedTabs[tabName]) {
            if (unlockedTabs[tabName]) {
                toggleMenu(tabName); // Already unlocked
            } else {
                setCurrentProtectedTab(tabName);
                setPasswordModalOpen(true);
            }
        } else {
            toggleMenu(tabName); // Normal tab
        }
    };


    const verifyTabPassword = () => {
        if (passwordInput === protectedTabs[currentProtectedTab]) {
            toast.success("Access Granted!");

            setUnlockedTabs({
                ...unlockedTabs,
                [currentProtectedTab]: true,
            });

            setPasswordModalOpen(false);
            setPasswordInput("");

            if (currentProtectedTab === "dashboard") {
                nevigate("/dashboard");
            } else {
                toggleMenu(currentProtectedTab);
            }

            // toggleMenu(currentProtectedTab);
        } else {
            toast.error("Wrong Password!");
        }
    };




    useEffect(() => {
        socket.on("new-payment", (data) => {
            setNotifications([...notifications, data]);

            // Play notification sound
            toast('New Order Added')
            if (audioRef.current) {
                audioRef.current.play().catch(error =>
                    console.error("Error playing sound:", error)
                );
            }
        });

        return () => {
            socket.off("new-payment");
            setNotifications([]);
        };
    }, []);

    // useEffect(() => {
    //     socket.on("new-bid", (data) => {
    //         setNewBid([...notifications, data]);
    //         // Play notification sound
    //         toast('New Bid Added')
    //         if (audioRef.current) {
    //             audioRef.current.play().catch(error =>
    //                 console.error("Error playing sound:", error)
    //             );
    //         }
    //     });

    //     return () => {
    //         socket.off("new-bid");
    //         setNewBid([]);
    //     };
    // }, []);

    useEffect(() => {
        socket.on("new-withdrawal", (data) => {
            setNotifications([...notifications, data]);
            // Play notification sound
            toast('New Withdrawal Added')
            if (audioRef.current) {
                audioRef.current.play().catch(error =>
                    console.error("Error playing sound:", error)
                );
            }
        });

        return () => {
            socket.off("new-withdrawal");
            setNotifications([]);
        };
    }, []);


    const toggleMenu = (menu) => {
        setOpenMenu(openMenu === menu ? null : menu);
    };

    const logoutHandler = async (e) => {
        e.preventDefault();
        try {
            dispatch(logout());
            nevigate('/signin');
        } catch (e) {
            console.log(e);
        }
    };

    return (
        <>
            <div id="wrapper">
                <audio ref={audioRef} src="https://assets.mixkit.co/active_storage/sfx/933/933-preview.mp3" autoPlay >
                    <track kind="captions" src="" default />
                </audio>
                <ul className={toggled ? 'navbar-nav sidebar sidebar-dark toggled' : 'navbar-nav sidebar sidebar-dark accordion'} id="accordionSidebar">
                    {/* <Link className="text-decoration-none justify-content-start" to="/dashboard"> */}
                        <div className="text-center">
                            <img src={logo} alt='adminlogo' className='img-fluid adminlogo' />
                        </div>
                    {/* </Link> */}

                    {/* <li className="nav-item text-dark">
                        <Link className="nav-link" to="/dashboard">
                            <MdDashboard className='mr-1' />
                            <span>Dashboard</span>
                        </Link>
                    </li> */}
                    <li className={`nav-item text-dark ${lastSegment === 'dashboard' ? 'active' : ''}`}>
                        <Link
                            className="nav-link"
                            to="#"
                            onClick={(e) => {
                                e.preventDefault();
                                handleTabClick("dashboard");
                            }}
                        >
                            <MdDashboard className='mr-1' />
                            <span>Dashboard</span>
                        </Link>
                    </li>


                    {/* Services */}
                    <li className={`nav-item text-dark ${lastSegment === 'products' ? 'active' : ''}`}>
                        <Link
                            className="nav-link text-dark collapsed"
                            href="#"
                            data-toggle="collapse"
                            aria-expanded={openMenu === 'products'}
                            // onClick={() => toggleMenu('products')}
                            onClick={() => {
                                handleTabClick('products')
                            }}
                        >
                            <RiMedicineBottleLine className='mr-1' />
                            <span>Services</span>
                        </Link>
                        <div
                            id="products"
                            className={`collapse ${openMenu === 'products' ? 'show' : ''}`}
                            aria-labelledby="headingTwo"
                        >
                            <div className="bg-white py-2 collapse-inner rounded">
                                <Link className="collapse-item" onClick={closeMenu} to="/products">Service List</Link>
                            </div>
                        </div>
                    </li>

                    {/* Add Category */}
                    <li className={`nav-item text-dark ${lastSegment === 'category' ? 'active' : ''}`}>
                        <Link
                            className="nav-link text-dark collapsed"
                            href="#"
                            data-toggle="collapse"
                            aria-expanded={openMenu === 'category'}

                            onClick={() => {
                                handleTabClick('category')
                            }}
                        >
                            <RiMedicineBottleLine className='mr-1' />
                            <span>Category</span>
                        </Link>
                        <div
                            id="category"
                            className={`collapse ${openMenu === 'category' ? 'show' : ''}`}
                            aria-labelledby="headingTwo"
                        >
                            <div className="bg-white py-2 collapse-inner rounded">
                                <Link className="collapse-item" to="/category/add" onClick={closeMenu}>Add Category</Link>
                                <Link className="collapse-item" to="/category" onClick={closeMenu}>Category List</Link>
                            </div>
                        </div>
                    </li>

                    {
                        user?.response?.data?.type !== 'users' && <>

                            {/* Add Users list */}
                            <li className={`nav-item text-dark ${lastSegment === 'add' || lastSegment === 'users' ? 'active' : ''}`}>
                                <Link
                                    className="nav-link text-dark collapsed"
                                    href="#"
                                    data-toggle="collapse"
                                    aria-expanded={openMenu === 'adminUser'}

                                    onClick={() => {
                                        handleTabClick('adminUser')
                                    }}

                                >
                                    <IoReceiptOutline className='mr-1' />
                                    <span> Service Men </span>
                                </Link>
                                <div
                                    id="adminUser"
                                    className={`collapse ${openMenu === 'adminUser' ? 'show' : ''}`}
                                    aria-labelledby="headingTwo"
                                >
                                    <div className="bg-white py-2 collapse-inner rounded">
                                        <Link className="collapse-item" to="/addservicemen" onClick={closeMenu}>Add Service Men</Link>
                                        <Link className="collapse-item" to="/servicemen" onClick={closeMenu}>Service Men List</Link>
                                    </div>
                                </div>
                            </li>

                            {/* QR code  */}
                            <li className={`nav-item text-dark ${lastSegment === 'qrcode' ? 'active' : ''}`}>
                                <Link
                                    className="nav-link text-dark collapsed"
                                    href="#"
                                    data-toggle="collapse"
                                    aria-expanded={openMenu === 'qrcode'}
                                    onClick={() => {
                                        handleTabClick('qrcode')
                                    }}
                                >
                                    <BsQrCode className='mr-1' />
                                    <span>QR code</span>
                                </Link>
                                <div
                                    id="banner"
                                    className={`collapse ${openMenu === 'qrcode' ? 'show' : ''}`}
                                    aria-labelledby="headingTwo"
                                >
                                    <div className="bg-white py-2 collapse-inner rounded">
                                        <Link className="collapse-item" to="/qrcode" onClick={closeMenu}>QR code list</Link>
                                    </div>
                                </div>
                            </li>

                            <li className={`nav-item text-dark ${lastSegment === 'banner' ? 'active' : ''}`}>
                                <Link
                                    className="nav-link text-dark collapsed"
                                    href="#"
                                    data-toggle="collapse"
                                    aria-expanded={openMenu === 'banner'}
                                    onClick={() => {
                                        handleTabClick('banner')
                                    }}
                                >
                                    <FaUsers className='mr-1' />
                                    <span>Users</span>
                                </Link>
                                <div
                                    id="banner"
                                    className={`collapse ${openMenu === 'banner' ? 'show' : ''}`}
                                    aria-labelledby="headingTwo"
                                >
                                    <div className="bg-white py-2 collapse-inner rounded">
                                        <Link className="collapse-item" to="/customer" onClick={closeMenu}>User List</Link>
                                    </div>
                                </div>
                            </li>
                        </>
                    }

                    {/* Customer Order list */}
                    <li className={`nav-item text-dark ${lastSegment === 'customerorder' ? 'active' : ''}`}>
                        <Link
                            className="nav-link text-dark collapsed"
                            href="#"
                            data-toggle="collapse"
                            aria-expanded={openMenu === 'gallery'}
                            onClick={() => {
                                setNotifications([])
                                toggleMenu('customerorder')
                            }}
                        >
                            <IoReceiptOutline className='mr-1' />
                            <span>Order List {notifications?.length ? <> <span className="badge badge-danger">New</span> </> : ''}</span>
                        </Link>
                        <div
                            id="gallery"
                            className={`collapse ${openMenu === 'customerorder' ? 'show' : ''}`}
                            aria-labelledby="headingTwo"
                        >
                            <div className="bg-white py-2 collapse-inner rounded">
                                <Link className="collapse-item" to="/customerorder" onClick={closeMenu}>Online Order
                                    List</Link>
                                {/* <Link className="collapse-item" to="/withdrawel">COD Order
                                    List</Link> */}
                            </div>
                        </div>
                    </li>

                    {/* Banner */}
                    <li className={`d-none nav-item text-dark ${lastSegment === 'banner' ? 'active' : ''}`}>
                        <Link
                            className="nav-link text-dark collapsed"
                            href="#"
                            data-toggle="collapse"
                            aria-expanded={openMenu === 'banner'}
                            onClick={() => toggleMenu('banner')}
                        >
                            <FaSlidersH className='mr-1' />
                            <span>Banner</span>
                        </Link>
                        <div
                            id="banner"
                            className={`collapse ${openMenu === 'banner' ? 'show' : ''}`}
                            aria-labelledby="headingTwo"
                        >
                            <div className="bg-white py-2 collapse-inner rounded">
                                <Link className="collapse-item" to="/banner/add" onClick={closeMenu}>Add Banner</Link>
                                <Link className="collapse-item" to="/banner" onClick={closeMenu}>Banner List</Link>
                            </div>
                        </div>
                    </li>
                    {/* <hr className="sidebar-divider d-none d-md-block text-dark" /> */}



                    <div className="text-center text-dark d-none d-md-inline mt-5">
                        <button className="rounded-circle border-0 text-dark" id="sidebarToggle" onClick={() => setToggle(!toggled)}></button>
                    </div>
                </ul>

                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <nav className="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">
                            <button id="sidebarToggleTop" onClick={() => setToggle(!toggled)} className="btn btn-link d-md-none rounded-circle mr-3">
                                <i className="fa fa-bars"></i>
                            </button>
                            <ul className="navbar-nav ml-auto">
                                {/* <div className="topbar-divider d-none d-sm-block"></div> */}
                                <li className="nav-item dropdown no-arrow">
                                    <Link className="nav-link dropdown-toggle" href="#" id="userDropdown" role="button"
                                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <span className="mr-2 d-none d-lg-inline admintext small">Admin</span>
                                        <IoPersonCircleSharp size={20} style={{ color: "#6a0dad" }} />
                                    </Link>
                                    <div className="dropdown-menu dropdown-menu-right shadow animated--grow-in"
                                        aria-labelledby="userDropdown">
                                        <div className="dropdown-divider"></div>
                                        <Button className="dropdown-item" text='Logout' onclickfun={logoutHandler} />
                                        <i className="fas fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400"></i>
                                    </div>
                                </li>
                            </ul>
                        </nav>
                        {children}
                    </div>
                </div>
            </div>
            {passwordModalOpen && (
                <div className="modal-backdrop show" style={{ zIndex: 9999 }}>
                    <div className="modal d-block" tabIndex="-1">
                        <div className="modal-dialog modal-sm modal-dialog-centered">
                            <div className="modal-content p-3">
                                <h5 className="text-center">Enter Password</h5>
                                <input
                                    type="password"
                                    className="form-control mt-2"
                                    placeholder="Enter password"
                                    value={passwordInput}
                                    onChange={(e) => setPasswordInput(e.target.value)}
                                />
                                <button className="btn btn-primary btn-block mt-3" onClick={verifyTabPassword}>
                                    Unlock
                                </button>
                                <button className="btn btn-light btn-block mt-2" onClick={() => setPasswordModalOpen(false)}>
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}


        </>
    );
};

export default Layout;
